<template>
  <div class="content">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="mb20 ftb">
      <el-breadcrumb-item>换电订单</el-breadcrumb-item>
      <el-breadcrumb-item>完成进度</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="df mb20">
      <p class="mr20 ft18">订单编号：{{}}</p>
      <p class="mr20 ft18">设备编号：{{}}</p>
      <p class=" ft18">投放地址：{{}}</p>
    </div>
    <div class="mb20">
      <el-button class="mr20" type="primary" @click="checkDetail">查看设备快照</el-button>
      <el-button class="mr20" type="primary" @click="checkRecord">查看发送请求记录</el-button>
    </div>
    <div class="stepBox">
      <el-steps direction="vertical" :active="2">
        <el-step :title=" '柜门已打开'"></el-step>
        <el-step title="请放入电池并关闭柜门" description="请务必确认插好电池"></el-step>
        <el-step :title="'号门正在打开'" description="这是一段很长很长很长的描述性文字"></el-step>
        <el-step title="请取出电池并关闭柜门" description=""></el-step>
      </el-steps>
    </div>


  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    checkDetail() {
      this.$router.push('');
    },
    checkRecord() {
      this.$router.push('');
    }
  },
  components: {}
}
</script>

<style scoped>
.stepBox {
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/installmentOrderMgmt.vue